<template>
  <button
    v-if="event && !event.drawn && !ticket.winner && !ticket.error && (typeof ticket.valid !== 'undefined')"
    @click="onClick()"
    class="btn btn-fill btn-icon"
    :class="!ticket.valid ? 'btn-info' : 'btn-error'"
    :title="!ticket.valid ? 'Validar ticket' : 'Invalidar ticket'"
  >
    <i :class="!ticket.valid ? 'ti-check' : 'ti-close'"></i>
  </button>
</template>

<script>
  import _ from 'lodash'
  import swal from 'sweetalert2'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'check-valid-online-register',

    props: {
      ticket: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        isWinnerTrgOlder: false,
        allTickets: []
      }
    },

    computed: {
      ...mapGetters('project', {
        config: 'project'
      }),

      events: {
        get () {
          return this.$store.state.events.all.reduce((acc, curr, indx) => {
            if (indx === 0) {
              acc = {}
            }
            acc[curr._id] = curr
            return acc
          }, {})
        }
      },

      event () {
        return this.events[this.ticket.eventId] ? this.events[this.ticket.eventId] : this.$store.state.events.one
      }
    },

    methods: {
      ...mapActions('tickets', ['upsertWithView', 'getTicketsByEvent', 'getTicketsByCustomer']),
      ...mapActions('tickets', {fetchTickets: 'fetchAll'}),
      ...mapActions('events', {findEvent: 'fetchOne'}),
      ...mapActions('customers', { fetchCustomer: 'fetchOne' }),

      onClick () {
        this.checkOldWinner().then((results) => {
          const promises = []
          for (const event of results) {
            promises.push(this.findEvent(event.eventId))
          }

          if (promises.length === 0) {
            return this.checkTicket().then(() => {
              this.getTickets()
            })
          }

          Promise.all(promises).then((events) => {
            const lastDateWinner = this.$moment(
                new Date(Math.max(...events.map(event => new Date(event.dateTimeCeremony))))
              )
            const today = this.$moment()
            const isContemplated = lastDateWinner.add(this.config.event.contemplatedPeriod, 'years')

            if (today.diff(isContemplated, 'years') >= 0) {
              this.checkTicket()
            } else {
              let validate = {valid: false}
              const doc = Object.assign({}, this.ticket, validate)
              doc.reasonNotEligible = 'Já foi contemplado anteriormente.'

              this.upsertWithView({
                find: {
                  ddoc: 'tickets-by-id',
                  view: 'tickets-by-id',
                  key: doc._id
                },
                payload: doc
              }).then(() => {
                swal({
                  title: '',
                  text: `Cliente já contemplado anteriormente.`,
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                })
              }).catch(err => {
                console.log(err)
                swal({
                  title: '',
                  text: `Ocorreu um problema ao validar ticket.`,
                  type: 'error',
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false
                })
              })
            }
          })

          this.getTickets()
        })
      },

      checkOldWinner () {
        const doc = Object.assign({}, this.ticket)
        return this.fetchTickets({
          select: ['eventId'],
          where: {customerId: doc.customerId, winner: true},
          limit: 99999
        }).then((results) => {
          return results
        })
      },

      async checkTicket () {
        let validate = {
          valid: !this.ticket.valid,
          eligible: !this.ticket.valid
        }
        const doc = Object.assign({}, this.ticket, validate)
        const customer = await this.fetchCustomer(doc.customerId)
        if (doc.valid && (doc.barcode === null || doc.barcode === undefined || doc.barcode === '')) {
          doc.barcode = `${customer.uc}${_.random(10000000, 99999999)}`
          delete doc.reasonNotEligible
        } else {
          doc.reasonNotEligible = 'Não foi validado por um atendente.'
          delete doc.barcode
        }
        return this.upsertWithView({
          find: {
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            key: doc._id
          },
          payload: doc
        })
          .then(() => {
            const options = {
              message: 'Ticket validado com sucesso.',
              type: 'success'
            }

            if (!doc.valid) {
              options.message = 'Ticket invalidado com sucesso.'
            }

            this.getTickets().then(() => {
              this.$notify(options)
            })
          })
          .catch(err => {
            console.log(err)
            swal({
              title: '',
              text: `Ocorreu um problema ao validar ticket.`,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          })
      },

      getTickets () {
        if (this.type === 'customer') {
          return this.getTicketsByCustomer(this.ticket.customerId)
        } else if (this.type === 'event') {
          return this.getTicketsByEvent(this.ticket.eventId)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/CheckValidOnlineRegister.vue